export interface SearchFieldModel {
  property: string;
  subProperty?: string;
  label?: string;
  name?: string;
  fieldType: FieldType;
  selectOptions?: any[];
  emptyOptionValue?: any;
  advancedOnly?: boolean;
  monthOnly?: boolean;
  displayField?: string;
  selectValue?: string;
  classes?: string;
  valueField?: string | boolean;
  reducerIndex?: string;
  selectDisplay?: string;
  eventName?: string;
  isRequired?: boolean;
  isMultiple?: boolean;
  maxLength?: number;
  maxValue?: number;
  unSelectFirst?: boolean;
  isSearchable?: boolean;
  showCalendarIcon?: boolean;
  initialSelected?: any;
  bootstrapColumn?: number;
  parentBootstrapColumn?: number;
  subFields?: string[];
  initialValue?: any;
  noEmptyOption?: boolean;
  withTooltip?: boolean;
}

export enum FieldType {
  TEXT_FIELD,
  NUMBER_FIELD,
  SELECT_FIELD,
  DATE_FIELD,
  RADIO_FIELD,
}

export interface GridColumn {
  header?: string;
  property: string;
  headerValue?: string;
  borderLeft?: boolean;
  backgroundClass?: string;
  hideSorting?: boolean;
  widthInPoints?: number;
  pattern?: string;
  escapeStrings?: boolean;
  isPercent?: boolean;
}

export enum ExportType {
  EXCEL = 'EXCEL',
  PDF = 'PDF',
  CSV = 'CSV',
  TXT = 'TXT',
  TIFF = 'TIFF',
  ALL = 'ALL',
  EXCEL_AND_CSV = 'EXCEL_AND_CSV',
  EXCEL_AND_PDF = 'EXCEL_AND_PDF',
}
